export default __webpack_public_path__ + "static/media/dresser004.b37e412b.jpeg";